import { render, staticRenderFns } from "./EditTeachingAndResearch.vue?vue&type=template&id=d71aeaea&scoped=true&"
import script from "./EditTeachingAndResearch.vue?vue&type=script&lang=js&"
export * from "./EditTeachingAndResearch.vue?vue&type=script&lang=js&"
import style0 from "./EditTeachingAndResearch.vue?vue&type=style&index=0&id=d71aeaea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71aeaea",
  null
  
)

export default component.exports